/**
 * What arms the delete.
 *
 * `toUpperCase` rather than `toLocaleUpperCase`: Turkish lowercases `I` to a dotless `ı`, so a
 * locale-aware fold would make „delete" never match. The word itself is never translated — the
 * mobile app's `accountErasure.ts` settles it the same way, and two apps asking one trainer for two
 * different words would be worse than either.
 */

export const ACCOUNT_ERASURE_CONFIRM_PHRASE = 'DELETE';

export function matchesConfirmationPhrase(typed: string): boolean {
  return typed.trim().toUpperCase() === ACCOUNT_ERASURE_CONFIRM_PHRASE;
}
